<template>
  <el-form size="mini" label-position="right" label-width="80px">
    <el-form-item label="时间戳">
      <el-col :span="15">
        <el-input
          v-model="model.timestamp"
          placeholder="时间戳"
          style="width: 100%"
          @change="conv0"
        />
      </el-col>
      <el-col :span="9">
        <el-select
          v-model="model.type"
          style="padding-left: 6px"
          popper-class="timestamp-conv-popper"
          @change="conv0"
        >
          <el-option label="秒(s)" :value="1000" />
          <el-option label="毫秒(ms)" :value="1" />
        </el-select>
      </el-col>
    </el-form-item>

    <el-form-item label="北京时间">
      <el-input
        :value="model.time"
        placeholder="北京时间"
        style="width: 100%"
      />
    </el-form-item>
  </el-form>
</template>

<script>
import dayjs from 'dayjs'
import { throttle } from 'lodash'

const formats = [
  'YYYY-MM-DD',
  'YYYY-MM-DD hh',
  'YYYY-MM-DD hh:mm',
  'YYYY-MM-DD hh:mm:ss',
  'YYYY/MM/DD',
  'YYYY/MM/DD hh',
  'YYYY/MM/DD hh:mm',
  'YYYY/MM/DD hh:mm:ss',
]

export default {
  data() {
    return {
      model: {
        type: 1,
        timestamp: '',
        time: '',
      },
    }
  },

  created() {
    this.conv0 = throttle(() => {
      this.model.time = ''
      const { timestamp, type } = this.model

      if (/^\d+$/.test(timestamp) && typeof type === 'number') {
        this.model.time = dayjs(parseInt(timestamp) * type).format(
          'YYYY-MM-DD hh:mm:ss'
        )
      }
    }, 500)
  },

  destroyed() {
    this.conv0.cancel()
  },
}
</script>

<style>
.timestamp-conv-popper {
  z-index: 9000 !important;
}
</style>
